import { render, staticRenderFns } from "./HomeFeedSocialChild.vue?vue&type=template&id=a7800258&scoped=true"
import script from "./HomeFeedSocialChild.vue?vue&type=script&lang=js"
export * from "./HomeFeedSocialChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7800258",
  null
  
)

export default component.exports